import React, { Fragment } from 'react';
import { DatePicker, Form, Input, Row, Col, Button, Checkbox } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter } from 'dva/router';
import PropTypes from 'prop-types';
import { CancelToken } from 'axios';
import helpers from '../../../utils/helpers';
import { defaultFiltersConfig } from '../../../utils/dataFilter';
import styles from '../styles.less';
import { RemoteSelectInput, SelectInput } from '../../../components';
import {
  branchesSearchRequest,
  searchClassificationCodes2ndLevelRequest,
} from '../../../services/branches';
import { leadScoringListRequest } from '../../../services/leadScoring';
import { WithHubspotProjectPermissions } from '../../Permissions';

const FormItem = Form.Item;
const Search = Input.Search;
const RangePicker = DatePicker.RangePicker;

class LeadsVisitsFilter extends React.Component {
  static propsTypes = {
    customBranches: PropTypes.string.isRequired, // the property filter used
    projectId: PropTypes.string.isRequired,
    selectedClientId: PropTypes.string.isRequired,
    showClearFilters: PropTypes.bool.isRequired,
    formFields: PropTypes.object.isRequired, // filter form fields
  }

  constructor(props) {
    super(props);

    this.state = {
      showKompassBranches: false,
      additionalFiltersHidden: true,
      allLeadMarks: [],
      allLeadScoringProfiles: [],
      isFilterModalOpen: false,
    };
  }

  componentDidMount() {
    this.props.dispatch({ type: 'countries/loadList' });
    this.props.dispatch({ type: 'leadLabels/loadList', payload: { filter: { client_id: this.props.selectedClientId } } }).then(({ data }) => this.setState({ allLeadMarks: data }));

    leadScoringListRequest({
      projectId: this.props.projectId,
      limit: 'unlimited',
      page: 1,
      sorting: 'id,asc',
      filter: '',
    }).then(i => this.setState({ allLeadScoringProfiles: i.data }));
  }

  clearFilters(e) {
    e.preventDefault();
    this.props.form.resetFields();
    this.props.resetFilters();
  }

  filterChange = () => {
    setTimeout(() => {
      const filters = this.props.form.getFieldsValue();
      this.props.onChange(filters);
    });
  }

  toggleFilters = () => {
    this.setState({
      additionalFiltersHidden: !this.state.additionalFiltersHidden,
    });
  }

  toggleFiltersModal = () => {
    this.setState({
      isFilterModalOpen: !this.state.isFilterModalOpen,
    });
  }

  branchesLoader = (query) => {
    let cancel;

    const queryPart = this.props.customBranches ?
      { filter: { name: `*${query}*` } } :
      { filter: { label: `*${query}*` } };

    const requestConfig = {
      cancelToken: new CancelToken((c) => {
        cancel = c;
      }),
    };

    const request = this.props.customBranches ?
      branchesSearchRequest(queryPart, requestConfig) :
      searchClassificationCodes2ndLevelRequest(queryPart, requestConfig);

    return {
      request,
      cancel,
    };
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form className={styles.targetGroup}>
        <Button
          className={`${styles.withIcon} filter-toggle`} size="large" type="primary"
          onClick={this.toggleFiltersModal}
        >
          <FormattedMessage id="Component.LeadsVisitsFilter.FilterAndSort" />
          <i className={[styles.btnIcon, styles.iconFilters].join(' ')} />
        </Button>
        <div className={`filter-main ${this.state.isFilterModalOpen ? 'open' : ''}`}>
          <div className="filter-main-inner">
            <h2 className="filter-title">
              <FormattedMessage id="Component.LeadsVisitsFilter.FilterAndSort" />
            </h2>
            <Button className={`${styles.withIcon} filter-modal-close`} onClick={this.toggleFiltersModal}>
              <i className={[styles.btnIcon, styles.iconFiltersClose].join(' ')} />
            </Button>
            <Row gutter={10} type="flex" align="top">
              <Col style={{ flex: 1 }}>
                <div className={styles.filterVisitsGrid}>
                  <div className="filter-grid__column">
                    <FormItem colon={false}>
                      {getFieldDecorator('dateRange', {
                        onChange: this.filterChange,
                        initialValue: this.props.formFields.dateRange,
                        required: true,
                      })(
                        <RangePicker allowClear={false} format={this.props.dateFormat} />,
                      )}
                    </FormItem>
                  </div>
                  <div className="filter-grid__column">
                    <FormattedMessage id="Component.LeadsVisitsFilter.Country">
                      {msg => (
                        <FormItem colon={false}>
                          {getFieldDecorator('countries', {
                            initialValue: this.props.formFields.countries,
                          })(
                            <SelectInput
                              showArrow
                              onBlur={this.filterChange}
                              onDeselect={this.filterChange}
                              mode="multiple"
                              placeholder={msg}
                              options={this.props.countries && this.props.countries.countriesList}
                              filterOption={helpers.multipleSelectFilter}
                            />,
                          )}
                        </FormItem>
                      )}
                    </FormattedMessage>
                  </div>
                  <div className="filter-grid__column">
                    <FormattedMessage id="Component.LeadsVisitsFilter.City">
                      {msg => (
                        <FormItem colon={false}>
                          {getFieldDecorator('city', {
                            initialValue: this.props.formFields.city,
                          })(
                            <Search
                              maxLength={255}
                              onSearch={this.filterChange}
                              placeholder={msg}
                            />,
                          )}
                        </FormItem>
                      )}
                    </FormattedMessage>
                  </div>
                  <div className="filter-grid__column">
                    <FormattedMessage id="Component.LeadsVisitsFilter.Score">
                      {msg => (
                        <FormItem colon={false}>
                          {getFieldDecorator('score', {
                            onChange: this.filterChange,
                            initialValue: this.props.formFields.score,
                          })(
                            <SelectInput
                              placeholder={msg}
                              filterOption={helpers.multipleSelectFilter}
                              options={defaultFiltersConfig.allScores}
                              idKey="value"
                              nameKey="label"
                            />,
                          )}
                        </FormItem>
                      )}
                    </FormattedMessage>
                  </div>
                  {!this.state.additionalFiltersHidden &&
                    <Fragment>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.Source">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('source', {
                                initialValue: this.props.formFields.source,
                              })(
                                <SelectInput
                                  showArrow
                                  onBlur={this.filterChange}
                                  onDeselect={this.filterChange}
                                  mode="multiple"
                                  placeholder={msg}
                                  filterOption={helpers.multipleSelectFilter}
                                  options={defaultFiltersConfig.allSources}
                                  nameKey="label"
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.Label">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('leadMarks', {
                                initialValue: this.props.formFields.leadMarks,
                              })(
                                <SelectInput
                                  showArrow
                                  onBlur={this.filterChange}
                                  onDeselect={this.filterChange}
                                  mode="multiple"
                                  placeholder={msg}
                                  filterOption={helpers.multipleSelectFilter}
                                  options={this.state.allLeadMarks}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.CompanyNameSearch">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('companyName', {
                                initialValue: this.props.formFields.companyName,
                              })(
                                <Search
                                  maxLength={255}
                                  onSearch={this.filterChange}
                                  placeholder={msg}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.CustomerNumberSearch">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('customerNumber', {
                                initialValue: this.props.formFields.customerNumber,
                              })(
                                <Search
                                  maxLength={255}
                                  onSearch={this.filterChange}
                                  placeholder={msg}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.Campaign">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('campaign', {
                                initialValue: this.props.formFields.campaign,
                              })(
                                <Search
                                  maxLength={255}
                                  onSearch={this.filterChange}
                                  placeholder={msg}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.CampaignName">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('campaignName', {
                                initialValue: this.props.formFields.campaignName,
                              })(
                                <Search
                                  maxLength={255}
                                  onSearch={this.filterChange}
                                  placeholder={msg}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.ScoringProfiles">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('scoringProfiles', {
                                initialValue: this.props.formFields.scoringProfiles,
                              })(
                                <SelectInput
                                  showArrow
                                  onBlur={this.filterChange}
                                  onDeselect={this.filterChange}
                                  mode="multiple"
                                  placeholder={msg}
                                  filterOption={helpers.multipleSelectFilter}
                                  options={this.state.allLeadScoringProfiles}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.ScoringProfilesVisibilityPlaceholder">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('scoringProfilesVisibility', {
                                initialValue: this.props.formFields.scoringProfilesVisibility,
                                onChange: this.filterChange,
                              })(
                                <SelectInput
                                  placeholder={msg}
                                  options={defaultFiltersConfig.allScoringProfileTypes}
                                  idKey="value"
                                  nameKey="label"
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.Branch">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('branches', {
                                initialValue: this.props.formFields.branches,
                              })(
                                <RemoteSelectInput
                                  labelInValue
                                  nameKey={this.props.customBranches ? 'name' : 'label'}
                                  remoteLoader={this.branchesLoader}
                                  showArrow
                                  onBlur={this.filterChange}
                                  onDeselect={this.filterChange}
                                  mode="multiple"
                                  placeholder={msg}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.CompanyVisibilityPlaceholder">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('companyVisibility', {
                                initialValue: this.props.formFields.companyVisibility,
                                onChange: this.filterChange,
                              })(
                                <SelectInput
                                  placeholder={msg}
                                  options={defaultFiltersConfig.allCompanyVisibilityFilters}
                                  idKey="value"
                                  nameKey="label"
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <WithHubspotProjectPermissions>
                        <div className="filter-grid__column">
                          <FormattedMessage id="Component.LeadsVisitsFilter.HubspotTask">
                            {msg => (
                              <FormItem colon={false}>
                                {getFieldDecorator('hubspotTask', {
                                  onChange: this.filterChange,
                                })(
                                  <SelectInput
                                    placeholder={msg}
                                    options={defaultFiltersConfig.hubspotTaskFilters}
                                    idKey="value"
                                    nameKey="label"
                                  />,
                                )}
                              </FormItem>
                            )}
                          </FormattedMessage>
                        </div>
                      </WithHubspotProjectPermissions>
                    </Fragment>
                  }
                </div>
                {!this.state.additionalFiltersHidden &&
                  <Row gutter={10} type="flex" align="top" justify="start" className={styles.filters}>
                    {this.props.customBranches &&
                      <Col>
                        {getFieldDecorator('showKompassBranches', {
                          initialValue: this.state.showKompassBranches,
                          valuePropName: 'checked',
                          onChange: (e) => {
                            this.props.showKompassBranches(e.target.checked);
                            this.setState({ showKompassBranches: e.target.checked });
                          },
                        })(
                          <Checkbox>
                            <FormattedMessage id="Component.LeadsVisitsFilter.ShowKompassBranches" />
                          </Checkbox>,
                        )}
                      </Col>}
                  </Row>
                }
              </Col>
              <Col style={{ flex: 0 }}>
                <Row>
                  <Col>
                    <Button
                      className={[styles.btnMoreLessFilters].join(' ')}
                      onClick={this.toggleFilters}
                      type="primary"
                      size="large"
                      shape="circle"
                      icon={this.state.additionalFiltersHidden ? 'plus' : 'minus'}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row type="flex" justify="space-between">
              <Col>
                {this.props.showClearFilters &&
                  <a
                    href="#" className={[styles.btnNoBorder, styles.clearAllBtn].join(' ')}
                    onClick={this.clearFilters.bind(this)}
                  >
                    <FormattedMessage id="Component.LeadsVisitsFilter.ClearAllFilters" />
                  </a>}
              </Col>
            </Row>
          </div>
        </div>
      </Form>
    );
  }
}

export default withRouter(connect(({ leads, countries, user }) => ({
  leads,
  countries,
  user,
}))(Form.create()(injectIntl(LeadsVisitsFilter))));



// WEBPACK FOOTER //
// ./src/components/Leads/LeadsVisitsFilter/LeadsVisitsFilter.js